import React from "react";
import { Outlet } from "react-router-dom";
import { Alert, Box, Button, CircularProgress, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { MarketOpsProvider, useMarketOps } from "./MarketOpsContext";

function Shell() {
  const ops = useMarketOps();
  return <Box sx={{ p: { xs: 1.5, md: 3 } }}>
    <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 800 }}>Market Operations</Typography>
      <Button onClick={ops.refresh} disabled={ops.loading || !ops.projectId}>Refresh</Button>
    </Stack>
    {!ops.projectId ? <Alert severity="info">Save or open a project to use Operations.</Alert>
      : !ops.authenticated ? <Alert severity="info">Sign in to load Operations.</Alert>
      : ops.loading ? <CircularProgress size={24} aria-label="Loading Operations" />
      : ops.error ? <Alert severity="error">{ops.error}</Alert>
      : ops.loaded && <Stack spacing={2}>
        {ops.isDirty && <Alert severity="warning">Operations uses the saved project. Save your changes, then refresh to update this view.</Alert>}
        <Alert severity="info">Live trading is not connected. Project status alone does not confirm market registration or enable submissions.</Alert>
        {ops.issues.map((issue) => <Alert key={issue} severity="info">{issue}</Alert>)}
        {ops.eligibleAssets.length > 0 ? <TextField select label="Operations asset" size="small" value={ops.asset?.id || ""}
          onChange={(e) => ops.setAssetId(e.target.value)} sx={{ maxWidth: 420 }}>
          {ops.eligibleAssets.map((a) => <MenuItem key={a.id} value={a.id}>{a.name || a.id}</MenuItem>)}
        </TextField> : <Alert severity="info">No operating assets. Update the asset status in Overview &amp; Assets when it is ready for onboarding.</Alert>}
        <Outlet />
      </Stack>}
  </Box>;
}
export default function MarketOpsShell() {
  return <MarketOpsProvider><Shell /></MarketOpsProvider>;
}
